export default __webpack_public_path__ + "0ace0b0681ba6b9c45b01bed84c5d1f1.png";